const topicItems = [
  { tag: '#顶流塌房', heat: '1.2亿', color: 'text-primary-600 bg-primary-50' },
  { tag: '#网红偷税', heat: '9876万', color: 'text-primary-600 bg-primary-50' },
  { tag: '#娱乐圈潜规则', heat: '8765万', color: 'text-accent-700 bg-accent-50' },
  { tag: '#综艺事故', heat: '7654万', color: 'text-accent-700 bg-accent-50' },
  { tag: '#明星恋情', heat: '6543万', color: 'text-secondary-700 bg-secondary-100' },
  { tag: '#片场耍大牌', heat: '5432万', color: 'text-secondary-700 bg-secondary-100' },
  { tag: '#17吃瓜爆料', heat: '4321万', color: 'text-primary-600 bg-primary-50' },
  { tag: '#内幕吃瓜', heat: '3210万', color: 'text-accent-700 bg-accent-50' },
  { tag: '#17黑料吃瓜', heat: '2987万', color: 'text-secondary-700 bg-secondary-100' },
  { tag: '#选秀黑幕', heat: '2654万', color: 'text-primary-600 bg-primary-50' },
];

export default function Topics() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1160px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 md:h-8 rounded-full bg-primary-500"></div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            话题广场
          </h2>
          <span className="text-xs text-foreground-400 mt-1 whitespace-nowrap">· 热度实时更新</span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {topicItems.map((item) => (
            <div
              key={item.tag}
              className={`rounded-xl p-4 md:p-5 transition-all duration-300 cursor-pointer hover:scale-[1.03] ${item.color}`}
            >
              <div className="font-semibold text-sm md:text-base mb-2 whitespace-nowrap">
                {item.tag}
              </div>
              <div className="flex items-center gap-1 text-xs opacity-70">
                <i className="ri-fire-line"></i>
                <span className="whitespace-nowrap">{item.heat}阅读</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}